import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthPermissionService } from '../services/auth/permission.service';
import { AppPermissions } from '../routes/permissions';

// CrystalX ships dark: every crystalx/* route also needs CrystalX_Access, in addition to its own permission
// (permissionsGuard ORs its list, so the gate lives in its own guard and canActivate ANDs them).
export const crystalxAccessGuard: CanActivateFn = () =>
  inject(AuthPermissionService).hasPermission(AppPermissions.CRYSTALX_ACCESS)
    ? true
    : inject(Router).createUrlTree(['/home']);
